import GATSBY_COMPILED_MDX from "/tmp/e4b36ba564ee40a8b67e9796594cb8dc/content/tutorials/account/organizations.md";
import React from "react";
import {graphql} from 'gatsby';
import Layout from "../components/layout";
import Sidebar from "../components/sidebar";
import Navbar from "../components/Navbar";
import {MDXProvider} from "@mdx-js/react";
import SEO from "../components/seo";
import TableOfContent from "../components/TableOfContent";
import SectionSummary from "../components/SectionSummary";
import SummaryBlocks from "../components/SummaryBlocks";
import DocsSummary from "../components/DocsSummary";
import ListItem from "../components/ListItem";
import Tabs from "../components/Tabs";
import TabsExtended from "../components/TabsExtended";
import TabDelimeter from "../components/TabDelimeter";
import StepTitleContent from "../components/post/StepTitleContent";
import Text from "../components/Text";
import Alert from "../components/Alert";
import StepTitle from "../components/post/StepTitle";
import CodeBlock from "../components/CodeBlock";
import IndexedTitle from "../components/post/IndexedTitle";
import Message from "../components/post/Message";
import ArrowedLink from "../components/post/ArrowedLink";
import ApiMethod from "../components/post/ApiMethod";
import ApiObject from "../components/post/ApiObject";
import Table from "../components/post/Table";
import ColoredText from "../components/post/ColoredText";
import Image from "../components/post/Image";
import ApiMethodBlock from "../components/post/ApiMethodBlock";
import Video from "../components/post/Video";
import ApiMessage from "../components/post/ApiMessage";
import CodeExample from "../components/api/CodeExample";
import ResponseExample from "../components/api/ResponseExample";
import ObjectsTable from "../components/api/ObjectsTable";
import TwoColumns from "../components/TwoColumns";
import API from "../components/api/";
import {article, container, body, mobileModeTracker, sidebarHidden, release} from "./doc-post.module.css";
const shortcodes = {
  SectionSummary,
  SummaryBlocks,
  DocsSummary,
  ListItem,
  Tabs,
  TabsExtended,
  TabDelimeter,
  StepTitleContent,
  Text,
  Alert,
  StepTitle,
  IndexedTitle,
  CodeBlock,
  Message,
  ArrowedLink,
  ApiMethod,
  ApiObject,
  Table,
  API,
  ColoredText,
  Image,
  ApiMethodBlock,
  Video,
  ApiMessage,
  CodeExample,
  ResponseExample,
  ObjectsTable,
  TwoColumns
};
function DocPost({data, children}) {
  const {mdx} = data;
  const currentPage = mdx.fields.slug;
  const isReleasePage = currentPage.startsWith('/release/') ? true : false;
  return React.createElement(Layout, null, React.createElement(SEO, {
    title: mdx.frontmatter.post_title,
    description: mdx.excerpt
  }), React.createElement(Navbar), React.createElement("div", {
    className: isReleasePage ? sidebarHidden : ''
  }, React.createElement(Sidebar, {
    submenuDataSourceName: mdx.frontmatter.data_json,
    postLink: currentPage
  })), React.createElement("div", {
    className: isReleasePage ? `${article} ${release}` : article
  }, React.createElement("div", {
    className: container
  }, React.createElement(TableOfContent, {
    postLink: currentPage
  }), React.createElement("div", {
    className: body
  }, React.createElement("h1", null, mdx.frontmatter.post_title), React.createElement(MDXProvider, {
    components: shortcodes
  }, children)))), React.createElement("div", {
    className: mobileModeTracker,
    id: "mobile-mode"
  }));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(DocPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      frontmatter {
        post_title
        data_json
      }
      fields {
        slug
      }      
      excerpt
    }
  }
`;
